import React, { FC } from 'react'
import { pageSectionMap } from '../../../../constants/urlSections.constants'
import { DisplayBreadcrumb } from './displayBreadcrumb'

type Props = {
  breadcrumb: any
  isBlogBreadcrumb: boolean
  entryLocale: string
  currentPathname: string
  pageName: string
}

export const GenerateBreadcrumb: FC<Props> = ({
  breadcrumb,
  isBlogBreadcrumb,
  entryLocale,
  currentPathname,
  pageName,
}) => {
  let sections: any[] = []
  let homeLink = ''

  if (breadcrumb) {
    breadcrumb.intermediateLinks?.forEach((link: any) => {
      let name = ''
      let sectionUrl = ''

      if (link?.internalLink?.name && link?.internalLink?.slug) {
        name = link.internalLink.name
        sectionUrl = link.internalLink.slug
      } else if (link?.text && link?.externalUrl) {
        name = link.text
        sectionUrl = link.externalUrl
      }

      if (name && sectionUrl) sections.push({ name, sectionUrl })
    })

    const homeEntryCTA = breadcrumb.home
    if (homeEntryCTA?.internalLink && homeEntryCTA?.internalLink?.slug) {
      homeLink = homeEntryCTA.internalLink.slug
      if (!homeLink.startsWith('/')) homeLink = `/${homeLink}`
    } else if (homeEntryCTA?.text && homeEntryCTA?.externalUrl) {
      homeLink = homeEntryCTA.externalUrl
    }
  } else {
    let pageSections = (pageSectionMap as any)[entryLocale]['global']

    if (isBlogBreadcrumb) {
      pageSections = (pageSectionMap as any)[entryLocale]['blog']
    }

    const resourcesBreadcrumb = {
      name: 'Resources',
      sectionUrl: '/resources',
    }

    if (pageSections) {
      const urlSections = Object.keys(pageSections)

      for (let urlSection of urlSections) {
        let matchingIdx = currentPathname.indexOf(urlSection)
        if (urlSection === '/blog' && matchingIdx > 2) continue

        if (matchingIdx !== -1) {
          let pageSection = pageSections[urlSection]
          const localePageName = pageSections[urlSection].localePageName || null

          if (pageSection.name !== pageName && localePageName !== pageName) {
            sections.push({
              name: pageSection.name,
              sectionUrl: pageSection.sectionUrl,
            })
          }
        }
      }
    }

    if (pageName === 'Demo Videos' || pageName === 'Videos' || pageName === 'Events') {
      sections = [resourcesBreadcrumb]
    }
  }

  return (
    <DisplayBreadcrumb
      homeLink={homeLink}
      entryLocale={entryLocale}
      sections={sections}
      pageName={pageName}
      currentPage={breadcrumb?.currentPage}
      nextPage={breadcrumb?.nextPage}
    />
  )
}
